import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { Patologia } from "../../../models/patologia";

@Component({
    selector: '[add_doc_to_patologia]',
  templateUrl: 'add-to-patologia.component.html',
})

export class AddDocumentoToPatologiaComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  entity: Patologia;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(patologia: Patologia) {
    this.onClickAddToEntity.emit(patologia);
  }
}
